import { Footer2 } from '../Footer2';

export function Footer() {
    return <Footer2 />;
}
